import { observable, action, runInAction } from "mobx";
import * as API from "../../../../api/m/recommend";
import { Dialog } from "@weapp/ui";
import * as InviteWelfareAPI from '../../../../api/inviteWelfare';

class MRecommendStore {
  @observable recommendData: object = {};
  @observable inviteWelfareInfo: any = {}; // 推荐福利
  @observable recordsData: object = {};

  @action
  getInitRecommend = () => {
    API.getInviteTeams()
      .then((res) => {
        runInAction(() => {
          this.recommendData = res;
        });
      })
      .catch((error: any) => {
        console.log(error);
      });
  };

  @action
  getInitRecords = (cb: Function) => {
    API.getRecommendInfo(0, 25).then((res: any) => {
      runInAction(() => {
        this.recordsData = res;
        cb()
      });
    });
  };
  @action
  getInviteRuleInfo = () => {
    InviteWelfareAPI.getInviteWelfare()
      .then((result: any) => {
        runInAction(() => {
          this.inviteWelfareInfo = result;
        });
      })
      .catch((error: any) => {
        console.log(error);
      });
  };
  @action
  onRecordChangePage = (pageNo: number | string, pageSize: number | string) => {
    API.getRecommendInfo(pageNo, pageSize)
      .then((res: any) => {
        runInAction(() => {
          this.recordsData = res;
        });
      })
      .catch((error: any) => {
        console.log(error);
      });
  };
}

const instance = new MRecommendStore();

export default instance;
